<template>
  <div class="flex flex-col space-y-5">
    <div class="">
      <div class="flex items-center justify-between">
        <div class="flex items-center text-[15px] space-x-1">
          <p>{{ $t("new.original_available_sale") }}</p>
        </div>
        <BaseSwitch
          :is-on="store.newArtwork.isForSale"
          @toggle-switch="store.togglePrice"
        />
      </div>
      <div class="mt-2.5">
        <BaseInput
          :label="$t('new.original_price_label')"
          :placeholder="$t('new.original_price_placeholder')"
          v-model.number="store.newArtwork.price"
          v-if="store.newArtwork.isForSale"
        />
      </div>
    </div>
    <!-- <div class="">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-1">
          <p>{{ $t("new.digital_available_sale") }}</p>
        </div>
        <BaseSwitch
          :is-on="store.newArtwork.isForSaleDigital"
          @toggle-switch="store.togglePriceDigital"
          :disabled="true"
        />
      </div>
      <div class="mt-2.5 relative">
        <BaseInput
          :label="$t('new.digital_price_label')"
          :placeholder="$t('new.digital_price_placeholder')"
          v-model.number="store.newArtwork.priceDigital"
          v-if="store.newArtwork.isForSaleDigital"
        />
        <div
          class="flex items-center justify-center px-1.5 py-0.5 absolute -right-0 -bottom-5 bg-yellow-500 text-white text-xs rounded-lg"
        >
          <span>{{ $t("common.not_available_yet") }}</span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup lang="ts">
const store = useNewArtworkStore();
</script>
